import axios from "axios";

const getCookie = (name) => {
let cookieValue = null;
if (document.cookie && document.cookie !== '') {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.substring(0, name.length + 1) === (name + '=')) {
      cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
      break;
    }
  }
}
return cookieValue;
};


const axiosGet = (url, params = {}) => {
    console.log(window.location.origin + url)
    return axios.get(window.location.origin + url, {
        headers: {
            'X-CSRFToken': getCookie('csrftoken'),
            'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
        params,
    });
};


const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };


export {getCookie, axiosGet, validateEmail}